type MetricType =
  | "cpu_ns"
  | "mem_ns"
  | "reserved_cpu_ns"
  | "reserved_mem_ns"
  | "gpu_mem_ns"
  | "gpu_util_ns"
  | "gpu_pow_util_ns"
  | "gpu_pow_ns"
  | "gpu_temp_ns"
  | "net_bytes_in"
  | "net_bytes_out"
  | "gpu_generic"
  | "task_ns"
  | "total_tasks_ns"
  | "function_fee_dollars"
  | "avg_pending_inputs"
  | "max_pending_inputs"
  | "avg_running_inputs"
  | "max_running_inputs";

export const metricColors: Record<MetricType, `#${string}`> = {
  cpu_ns: "#bef264",
  mem_ns: "#fde047",
  reserved_cpu_ns: "#747969",
  reserved_mem_ns: "#7c7764",
  gpu_mem_ns: "#4ade80",
  gpu_util_ns: "#fffdd0",
  gpu_pow_util_ns: "#fdd0e6",
  gpu_temp_ns: "#ffa07a",
  net_bytes_in: "#7586ff",
  net_bytes_out: "#b170ff",
  gpu_generic: "#add0e6",
  task_ns: "#ffcc87",
  total_tasks_ns: "#c68300",
  function_fee_dollars: "#9ca3af",
  gpu_pow_ns: "#fdd0e6",
  max_pending_inputs: "#538dff",
  avg_pending_inputs: "#c4d4ff",
  max_running_inputs: "#ef52c1",
  avg_running_inputs: "#ffc3e5",
};

type MetricColorKey = keyof typeof metricColors;
export type MetricColor = (typeof metricColors)[MetricColorKey];

/**
 * Get the x-axis domain for a timeseries metric chart.
 * @param duration - The duration of the chart in seconds.
 * @param timeRange - The start and end of the chart also in seconds.
 * @returns The x-axis domain.
 */
export function getXDomain(
  duration: number,
  timeRange: [number, number] | undefined,
): [Date, Date] {
  if (timeRange) {
    return [new Date(timeRange[0] * 1000), new Date(timeRange[1] * 1000)];
  }
  return [new Date(Date.now() - duration * 1000), new Date()];
}
